import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Hosteleria from "@/pages/Hosteleria";
import Formacion from "@/pages/Formacion";
import Historia from "@/pages/Historia";
import Contacto from "@/pages/Contacto";
import Legal from "@/pages/Legal";
import QrRedirect from "@/pages/QrRedirect";
import Kit from "@/pages/Kit";
import NotFound from "@/pages/NotFound";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import { Toaster } from "@/components/ui/sonner";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    const id = hash.slice(1);
    const t = setTimeout(
      () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }),
      240
    );
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cafe/:id" element={<Product />} />
            <Route path="/hosteleria" element={<Hosteleria />} />
            <Route path="/formacion" element={<Formacion />} />
            <Route path="/historia" element={<Historia />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/qr" element={<QrRedirect />} />
            <Route path="/kit" element={<Kit />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
